import styled from "styled-components";
import { Layout as AntdLayout } from "antd";

import { featureFlags } from "@settings";

const { Header: AntdHeader, Content: AntdContent } = AntdLayout;

const HEADER_HEIGHT = 50;

export const Layout: typeof AntdLayout = styled(AntdLayout)`
  height: 100%;
`;

export const Header = styled(AntdHeader)`
  height: ${HEADER_HEIGHT}px;
  width: 100%;
  background: ${({ theme }) => theme.token.colorPrimary};

  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 0 16px;
  box-shadow: 0 -1px 0 0 #f0f0f0 inset;
`;

export const SiderContainer = styled.div`
  height: calc(100vh - ${HEADER_HEIGHT}px);

  .ant-layout-sider-trigger {
    display: flex;
    align-items: center;
    justify-content: flex-start;

    padding-left: 16px;
    border-top: 1px solid #e5e5e5;
    background: #fff;
  }

  .ant-layout-sider-collapsed .ant-layout-sider-trigger {
    justify-content: center;
    padding-left: 0;
  }
`;

export const MobileOverlay = styled.div`
  position: fixed;
  top: ${HEADER_HEIGHT}px;
  left: 0;
  width: 100%;
  height: calc(100vh - ${HEADER_HEIGHT}px);
  background: rgba(0, 0, 0, 0.3);
  z-index: 999;
`;

export const MobileSidebar = styled.div`
  position: fixed;
  top: ${HEADER_HEIGHT}px;
  left: 0;
  width: 100%;
  height: calc(100vh - ${HEADER_HEIGHT}px);
  background: #fff;
  z-index: 1000;
  overflow-y: auto;
`;

export const Content = styled(AntdContent)`
  height: 100%;
  overflow: auto;
  ${featureFlags.enablePublicConsigLayout &&
  `min-height: calc(100vh - ${HEADER_HEIGHT}px);`}
`;
